import { getCaller } from 'src/utils/urls';
import { getPersonDetails } from 'src/utils/urls';

import { PersonType } from 'src/types/personType';

async function fetchCaller({
  token,
  tokenType,
  accountId,
  personId,
  updatePersonLog,
}: {
  token: string;
  tokenType: string;
  accountId: number | undefined;
  personId: number | undefined;
  updatePersonLog?: boolean;
}): Promise<PersonType> {
  let url = getCaller(accountId, personId);
  if (updatePersonLog === false) {
    url = getPersonDetails(accountId, personId, updatePersonLog);
  }
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      Authorization: `${tokenType} ${token}`,
    },
  });
  return response.json();
}

export { fetchCaller };
